import React, { createContext, useContext, useMemo, useState, ReactNode } from 'react';
import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';

interface InsuranceTypeContextValue {
  insuranceType: InsuranceType;
  setInsuranceType: (type: InsuranceType) => void;
}

const InsuranceTypeContext = createContext<InsuranceTypeContextValue | null>(null);

interface InsuranceTypeProviderProps {
  children: ReactNode;
  insuranceType?: InsuranceType; // Optional prop to set initial insurance type, defaults to PRIMARY
}

// Centralized provider for managing and updating the selected insurance type(primary, secondary).
export const InsuranceTypeProvider: React.FC<InsuranceTypeProviderProps> = ({
  insuranceType = InsuranceType.INSURANCE_TYPE_PRIMARY,
  children,
}) => {
  const [insuranceTypeState, setInsuranceType] = useState<InsuranceType>(insuranceType);

  const value = useMemo(() => ({ insuranceType: insuranceTypeState, setInsuranceType }), [insuranceTypeState]);

  return <InsuranceTypeContext.Provider value={value}>{children}</InsuranceTypeContext.Provider>;
};

export const useInsuranceType = (): InsuranceTypeContextValue => {
  const context = useContext(InsuranceTypeContext);
  if (!context) {
    throw new Error('useInsuranceType must be used within an InsuranceTypeProvider');
  }
  return context;
};
